import { readSessionStorage, writeSessionStorage } from '@/lib/safeStorage';

const reloadedAtKey = 'preload-error-reload';
const minReloadIntervalMs = 60_000;

/**
 * A page from the previous deploy references hashed chunks that are gone, so Vite's preload of
 * them fails. A reload fetches the current page and its chunks.
 *
 * At most one reload per minute: a chunk that is still missing afterwards is a real fault and must
 * surface as the error. Without sessionStorage there is no loop guard, so no reload either.
 */
export const installPreloadErrorReload = () => {
  window.addEventListener('vite:preloadError', (event) => {
    // a reload would discard unsaved work in the Experience Editor
    if (window.firstState?.sitecore?.data?.isEditMode) {
      return;
    }
    const lastReload = Number(readSessionStorage(reloadedAtKey));
    if (lastReload && Date.now() - lastReload < minReloadIntervalMs) {
      return;
    }
    if (!writeSessionStorage(reloadedAtKey, String(Date.now()))) {
      return;
    }
    event.preventDefault();
    window.location.reload();
  });
};
